import { render, staticRenderFns } from "./ClientsReports.vue?vue&type=template&id=59feb2fb&scoped=true"
import script from "./ClientsReports.vue?vue&type=script&lang=js"
export * from "./ClientsReports.vue?vue&type=script&lang=js"
import style0 from "./ClientsReports.vue?vue&type=style&index=0&id=59feb2fb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59feb2fb",
  null
  
)

export default component.exports